import React, { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const AlterCalculatedPriceTooltip: FC = ({ children }) => (
  <Tooltip
    title="Alter the Calculated total by adjusting the individual calculations in the Workspace to your left"
    placement="top"
  >
    {children}
    <InfoCircleOutlined style={{ marginLeft: 5 }} />
  </Tooltip>
);
